import { CAMPAIGNS } from '../pages/qr-redirect/redirects';

export const GA_MEASUREMENT_ID = 'G-2NJFJRC2P8';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

const SITE_NAME = 'PADU';
const DEFAULT_TITLE = 'PADU | Το κορυφαίο app επιβράβευσης στην Ελλάδα';

const ROUTE_TITLES: Record<string, string> = {
  '/': DEFAULT_TITLE,
  '/about': 'Σχετικά',
  '/padu-app': 'PADU App',
  '/partners': 'Συνεργάτες',
  '/contact': 'Επικοινωνία',
  '/ta-nea-mas': 'Τα Νέα Μας',
  '/loyalty': 'Loyalty',
  '/promo-and-rewards': 'Promo & Rewards',
  '/benefits': 'Benefits',
  '/digital-signage': 'Digital Signage',
  '/music-audio-messaging': 'Music & Audio Messaging',
  '/retail-media': 'Retail Media',
  '/streamee-for-bussiness': 'Streamee for Business',
  '/nova': 'Nova',
  '/zita-plirofories-kai-prosfora': 'Ζήτα Πληροφορίες & Προσφορά',
  '/antamoivi-se-kathe-agora': 'Ανταμοιβή σε κάθε αγορά',
  '/programmata-pistotitas': 'Προγράμματα Πιστότητας',
  '/miniaies-klirosis': 'Μηνιαίες Κληρώσεις',
  '/terms': 'Όροι Χρήσης',
  '/oroi-xrisis': 'Όροι Χρήσης',
  '/privacy': 'Πολιτική Απορρήτου',
  '/politiki-aporritou': 'Πολιτική Απορρήτου',
  '/cookies': 'Πολιτική Cookies',
};

// QR campaign paths are declared in redirects.ts; reuse the campaign name so
// scans show up in GA as "OPEN TV" rather than a bare "/qr-open/".
for (const campaign of CAMPAIGNS) {
  for (const path of campaign.paths) {
    ROUTE_TITLES[normalize(path)] = `QR: ${campaign.name}`;
  }
}

/** Trailing slashes vary between the router config and the address bar. */
function normalize(pathname: string): string {
  return pathname !== '/' && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
}

/** The admin area is internal tooling — keep it out of the reports entirely. */
function isTracked(pathname: string): boolean {
  return !pathname.startsWith('/admin');
}

export function titleForPath(pathname: string): string {
  const path = normalize(pathname);
  if (path.startsWith('/qr-landing/')) return 'QR Landing';

  const title = ROUTE_TITLES[path];
  if (!title) return DEFAULT_TITLE;
  return title === DEFAULT_TITLE ? title : `${title} | ${SITE_NAME}`;
}


let previousUrl: string | undefined;

export function trackPageView(pathname: string, search: string): void {
  document.title = titleForPath(pathname);
  if (!isTracked(pathname)) return;

  // GA4 derives the page path from `page_location`; there is no `page_path`
  // parameter (that was Universal Analytics) and sending one is ignored.
  window.gtag?.('event', 'page_view', {
    page_location: window.location.href,
    page_title: document.title,
    ...(previousUrl ? { page_referrer: previousUrl } : {}),
  });

  previousUrl = window.location.href;
}


export function trackEvent(name: string, params: Record<string, unknown> = {}): void {
  window.gtag?.('event', name, params);
}
